module.exports = __webpack_public_path__ + "static/media/BG_1.6a57daac.mp4";